import React, { useState } from 'react';
import { motion } from 'framer-motion';
import './NewColourMode.css';


const NewColourMode = ({isColourMode, setIsColourMode, customStyling=null, initialDelay=0}) => {
  const handleClick = () => {
    setIsColourMode(!isColourMode);
  };

  const rgbVariants={
    initial: {
      opacity: 0
    }, animate: {
      opacity: 1,
      transition: {
        duration: 1.5,
        ease: [0.16, 1, 0.3, 1]
      }
    }, exit: {
      opacity: 0,
      duration: 1
    }
  }

  const rgbParentVariants = {
    initial: {

    }, animate: {
      transition:{
        delayChildren: initialDelay,
        staggerChildren: 0.15
      }
    }, exit: {
      transition:{
        staggerChildren: 0.15
      }
    }
  }

  return (
    <motion.div 
      className={`rgb ${!isColourMode ? 'white-mode': 'col-mode'}`} onClick={handleClick}
      initial="initial"
      animate="animate"
      exit="exit"
      variants={rgbParentVariants}
      style={customStyling}
    >
        <motion.span className='r' variants={rgbVariants}></motion.span>
        <motion.span className='g' variants={rgbVariants}></motion.span>
        <motion.span className='b' variants={rgbVariants}></motion.span>
    </motion.div>


//     <svg xmlns="http://www.w3.org/2000/svg" width="303" height="139" viewBox="0 0 303 139" fill="none" onClick={handleClick}>
//     <ellipse 
//       filter="url(#filter0_f_409_1715)" 
//       style={{ mixBlendMode: 'screen' }} 
//       rx="14.780406" 
//       ry="14.780406" 
//       transform="translate(30.788295 15.219594)" 
//       fill="#f00" 
//       strokeWidth="0" 
//     />
//     <ellipse 
//       filter="url(#filter0_f_409_1715)" 
//       style={{ mixBlendMode: 'screen' }} 
//       rx="14.780406" 
//       ry="14.780406" 
//       transform="translate(50 15)" 
//       fill="#00ff25" 
//       strokeWidth="0" 
//     />
//     <ellipse 
//       filter="url(#filter0_f_409_1715)" 
//       style={{ mixBlendMode: 'screen' }} 
//       rx="14.780406" 
//       ry="14.780406" 
//       transform="translate(69.769677 15)" 
//       fill="#0040ff" 
//       strokeWidth="0" 
//     />
//     <defs>
//       <filter id="filter0_f_409_1715" x="0" y="0" width="30" height="30" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
//         <feFlood floodOpacity="0" result="BackgroundImageFix" />
//         <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
//         <feGaussianBlur stdDeviation="2" result="effect1_foregroundBlur_409_1715" />
//       </filter>
//       <filter id="filter1_f_409_1715" x="73" y="0" width="30" height="30" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
//         <feFlood floodOpacity="0" result="BackgroundImageFix" />
//         <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
//         <feGaussianBlur stdDeviation="2" result="effect1_foregroundBlur_409_1715" />
//       </filter>
//       <filter id="filter2_f_409_1715" x="164" y="0" width="30" height="30" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
//         <feFlood floodOpacity="0" result="BackgroundImageFix" />
//         <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
//         <feGaussianBlur stdDeviation="2" result="effect1_foregroundBlur_409_1715" />
//       </filter>
//     </defs>
//   </svg>
  );
};

export default NewColourMode;
